import { render, staticRenderFns } from "./UpdateDictionaryType.vue?vue&type=template&id=4e04b1f6&"
import script from "./UpdateDictionaryType.vue?vue&type=script&lang=ts&"
export * from "./UpdateDictionaryType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports